import cn from "clsx";
import { jsx as _jsx } from "react/jsx-runtime";
var CoursesCounterTag = function CoursesCounterTag(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_jsx("div", {
    className: cn(
    // Font
    'tw-font-caption tw-text-neutral-light-800 dark:tw-text-neutral-dark-800',
    // Rounded
    'tw-rounded-0.4',
    // Padding
    'tw-px-0.8 tw-pt-0.4',
    // Background
    'tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-400',
    // Size
    'tw-h-2.4',
    // Margin
    'tw-mr-1.2'),
    children: label
  });
};
export default CoursesCounterTag;